module.exports = __webpack_public_path__ + "static/img/shz.aac21ba0.png";